import React from 'react';
import { getFavoriteTournamentsData } from '../../data/utils/getFavoriteTournamentsData';
import { iconSportCssClass } from '../../data/utils/iconSportCssClass';
import { labels } from '../../data/labels';
import { PrematchContext } from '../Prematch';
import MenuCategoryItem from './MenuCategoryItem';

function FavoriteTournaments(props) {
    const prematchContext = React.useContext(PrematchContext);
    let sportList = getFavoriteTournamentsData(props.data.sport, prematchContext.favoriteTournaments, prematchContext.temporalFilter.type).sportsList;

    const items = sportList.map(function (t) {
        return (
            <React.Fragment key={t.id}>
                <div className="list-element sport-collapse">
                    <div className={`prematch-sport-img big ${iconSportCssClass(t.id, t.iconClass)}`}></div>
                    <span className="list-element-text list-heading">{t.descrizione}</span>
                    <div className="d-flex push-right mr-2">
                        {t.isLive &&
                            <div className="badge-live mr-2"></div>
                        }
                        <span className="list-element-info"></span>
                    </div>
                </div>
                {t.competitions.map(function (r) {
                    function handleClick() {
                        prematchContext.openTournament(r.uniqueId, true);
                    }
                    console.log(r);

                    return (
                        <MenuCategoryItem key={r.id}
                                            id={r.id}
                                            desc={r.descrizione}
                                            info={r.eventsCount}
                                            sportRef={r.sportRef}
                                            categoryRef={r.categoryRef}
                                            iconClass={r.iconClass}
                                            isLive={r.isLive}
                                            action={handleClick}
                                            showPinToggle={true}
                                            urlPath={r.urlPath}
                                            urlPathSuffix={r.urlPathSuffix}
                                            urlPathSeo={r.urlPathSeo}
                                            urlPathSeoSettings = {r.urlPathSeoSettings} />
                    );
                })}
            </React.Fragment>
        );
    });

    return (
        <>
            {sportList.length > 0 &&
                <>
                    <span className="list-heading">{labels['navbar_buttons.favorite_tournaments']}</span>
                    <div className="menu-container">
                        <div className="menu-container">
                        </div>{items}
                    </div>
                </>
            }
        </>
    );
}

export default FavoriteTournaments;